<template>
  <div class="open-app">
    <p v-if="showSafariGuide">
      현재 브라우저에서는 앱을 열 수 없습니다. <br />
      👉 오른쪽 상단 [ ⋯ ] 버튼 → [Safari로 열기]를 눌러주세요.
    </p>
    <p v-else>앱을 여는 중입니다... 잠시만 기다려주세요.</p>
    <a ref="iosLink" :href="target" style="display: none;">앱 열기</a>
  </div>
</template>

<script>
export default {
  name: 'OpenApp',
  data() {
    return {
      fallbackUrl: '',
      showSafariGuide: false,
      target : 'www.zikoo.co.kr'
    };
  },
  created() {
  const encodedPath = this.$route.query.target;
    if (!encodedPath) return;

    const decodedPath = decodeURIComponent(encodedPath); // ex: /product/123414
    let schemeUrl = `${process.env.VUE_APP_MAIN_URL}${decodedPath}`;       // 최종 딥링크

    const userAgent = navigator.userAgent || navigator.vendor;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const fallbackUrl =  `${process.env.VUE_APP_MAIN_URL}${decodedPath}`;
     //   const fallbackAndroidUrl = `https://play.google.com/store/apps/details?id=com.zikooapp&referrer=${decodedPath}`;
    if(!isIOS){
      schemeUrl = `intent://zikoo.co.kr/${decodedPath}#Intent;scheme=https;package=com.zikooapp;S.browser_fallback_url=${fallbackUrl};end`;
    
    }
    alert(schemeUrl);
    window.location.href = schemeUrl;

  },

};
</script>

<style scoped>
.open-app {
  padding: 40px;
  text-align: center;
  font-size: 16px;
}
</style>
